import { IVocCategory } from '../../../types/vocCategories';

// IllustrationAwareInterface constants (must match backend)
const ILLUSTRATION_STATUS_DONE = 3;

/**
 * Cell renderer for VocCategory illustration status
 * Only sub-categories can have illustrations
 * Status: 0 = no image (red), 3 = done (green)
 */
export function vocCategoryIllustrationRenderer(param: { data: IVocCategory }) {
  const { data } = param;

  // Root categories don't have illustrations
  if (!data.isSubCategory) {
    return '';
  }

  // 0 = no image (red), 5 = done (green)
  const color = data.illustration === ILLUSTRATION_STATUS_DONE ? '#00cc00' : '#ff0000';
  return `<span class='fa fa-image' style='color: ${color}'/>`;
}
